import {
	AfterViewInit,
	Component, ElementRef,
	Input, OnChanges,
	OnInit, ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import {GenericConfig, EntityConfig} from "@signature-it/ngx-generic/config";
import { CarouselService } from '@signature-it/ngx-generic/services';

import { EntityService} from '@signature-it/ngx-entity/services';
import { SwiperOptions } from 'swiper';
import {Store} from "@ngrx/store";
declare let _ : any;
import * as EntityActions from '@signature-it/ngx-entity/store/actions';
import * as EntitySelectors from '@signature-it/ngx-entity/store/selectors';
import SwiperCore, { Navigation, Pagination, Scrollbar, Autoplay, Thumbs} from 'swiper';
import {SwiperComponent} from "swiper/angular";

SwiperCore.use([Navigation, Pagination, Scrollbar, Autoplay, Thumbs]);
declare let $: any;

@Component({
    selector: 'swiperjs',
    templateUrl: './swiperjs.component.html',
    styleUrls: ['./swiperjs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SwiperjsComponent implements OnChanges, OnInit, AfterViewInit {
	@Input() key: string = 'default';
	@Input() ticker: boolean = false;
	@Input() ma_api: string = null;
	_direction: string = '';
	@Input() set direction(value){
		if (value && ['ltr', 'rtl'].indexOf(value) > -1) {
			this._direction = value;
		}
	}
	@ViewChild('swiper') swiper: SwiperComponent;
	@ViewChild('marquee') marquee: ElementRef;
	swiperConfig: SwiperOptions = {};
	previewTemplateVar: string;
	@Input() swiperImagesConfig: object = null;
	@Input() api: string = null;
	items;
	templates$;
	showPlayButton: boolean = false;
	isPlay: boolean = true;
	htmlContents: Array<string>;
	thumbsSwiperConfig :object = {};
	thumbsSwiper: any;
	CDNPrefix = GenericConfig.CDNPrefix || '';
	noImage : string;
	loopMin : number;
	constructor(protected entiyService: EntityService, protected store$: Store<any>,
				protected carouselService: CarouselService) {
		this.templates$ = this.store$.select(EntitySelectors.getPreviews);
	}

	ngOnInit() {
		this.store$.dispatch(EntityActions.getPreviews());
	}
	ngAfterViewInit() {
		if (this.ticker && this.marquee){
			var $wrapper = this.marquee.nativeElement;
			var $container = $wrapper.querySelector('.scrollableArea > div');
			var _speed = 52;
			var distance1 = $container.offsetWidth;
			var duration =  distance1/_speed;
			var clonedContainer = $container.cloneNode(true);
			var scrollableArea = $wrapper.querySelector('.scrollableArea');

			scrollableArea.appendChild(clonedContainer);
			scrollableArea.style.width = (distance1 * 2) + "px";
			if (this._direction == 'ltr') {
				distance1 = -distance1;
			}
			$(document.body).append('<style>#scrollingText .scrollableArea.play > div{-webkit-animation:marquee '+duration+'s linear infinite;-moz-animation:marquee '+duration+'s linear infinite;-ms-animation:marquee '+duration+'s linear infinite;-o-animation:marquee '+duration+'s linear infinite;animation:marquee '+duration+'s linear infinite;animation-play-state: running;-webkit-animation-play-state: running;}@-webkit-keyframes marquee{0%{-webkit-transform:translateX(0)}100%{-webkit-transform:translateX('+distance1+'px)}}@-moz-keyframes marquee{0%{-moz-transform:translateX(0)}100%{-moz-transform:translateX('+distance1+'px)}}@-ms-keyframes marquee{0%{-ms-transform:translateX(0)}100%{-ms-transform:translateX('+distance1+'px)}}@-o-keyframes marquee{0%{-o-transform:translateX(0)}100%{-o-transform:translateX('+distance1+'px)}}@keyframes marquee{0%{transform:translateX(0)}100%{transform:translateX('+distance1+'px)}}</style>');
		}
	}


	ngOnChanges() {
		if (EntityConfig.ngxSwiperjs[this.key])
			this.setConfig(EntityConfig.ngxSwiperjs[this.key]);
		if (this.swiperImagesConfig)
			this.setConfig(this.swiperImagesConfig);
		this.applyApi();
	}

	setConfig(config) {
		this.swiperConfig = config['swiperConfig'];
		this.thumbsSwiperConfig = config['thumbsSwiper'];
		if (this.thumbsSwiperConfig && this.thumbsSwiperConfig['api']) {
			this.entiyService.callApi(this.thumbsSwiperConfig['api']).subscribe(
				response => {
					this.thumbsSwiperConfig['items'] = response?.['response']?.['docs'] || response;
				}
			)
		}
		this.previewTemplateVar = config['previewTemplateVar'] ? config['previewTemplateVar']: this.previewTemplateVar;
		this.api = config['api'] ? config['api'] : this.api;
		this.ma_api = config['ma_api'] ? config['ma_id'] : this.ma_api;
		this.showPlayButton = config['showPlayButton'];
		this.htmlContents = config['htmlContents'] ? config['htmlContents'].filter(function (v) {
			return v !== ''
		}) : null;
		this.noImage = config['noImage'];
		this.loopMin = config['loopMin'] ? config['loopMin'] : 0;
	}
	applyApi(){
		if (this.api) {
			this.entiyService.callApi(this.api).subscribe(
				response => {
					let items = response?.['response']?.['docs'] || response;
					this.items =  items.data ? Object.values(items.data) : items;
					if (this.ticker) {
						setTimeout(() => {
							this.ngAfterViewInit();
						}, 2000);
					}
					if (this.loopMin > 0 && this.items.length >= this.loopMin){
						this.swiperConfig['loop'] = true;
					}
					else{
						this.swiperConfig['loop'] = false;
					}
					this.getOtherData(this.items);
				}
			)
		} else if (this.ma_api){
			this.carouselService.getGalleryFromApi(this.ma_api).subscribe(
				response => {
					this.items =  response.filter(function (v) {return v.showInGallery});
					this.thumbsSwiperConfig['items'] = this.items;
				}
			);
		}
	}

	getOtherData(items) {}

	startPlay() {
		if(this.swiper) {
			this.swiper.swiperRef.autoplay.start();
			this.isPlay = true;
		}
		if (this.ticker){
			this.isPlay = true;
		}
	}

	stopPlay() {
		if(this.swiper) {
			this.swiper.swiperRef.autoplay.stop();
			this.isPlay = false;
		}
		if (this.ticker){
			this.isPlay = false;
		}
	}
}
